import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChecklistReportListDataService } from './checklist-report-list-data.service';
import { ChecklistReportLastActivePeriodStatusColumnComponent } from './checklist-report-last-active-period-status-column/checklist-report-last-active-period-status-column.component';
import { ChecklistReportLastActivePeriodStatusGridColumnComponent } from './checklist-report-last-active-period-status-grid-column/checklist-report-last-active-period-status-grid-column.component';
import { ChecklistReportLastActivePeriodStatusHeaderComponent } from './checklist-report-last-active-period-status-header/checklist-report-last-active-period-status-header.component';
import { ChecklistReportListComponent } from './checklist-report-list.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { ComponentsModule } from '@fi-app/components/components.module';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [CommonModule, UtilitiesModule, ComponentsModule, FiItemsListModule, MatButtonModule, MatIconModule],
    declarations: [
        ChecklistReportLastActivePeriodStatusGridColumnComponent,
        ChecklistReportLastActivePeriodStatusHeaderComponent,
        ChecklistReportLastActivePeriodStatusColumnComponent,
        ChecklistReportListComponent,
    ],
    providers: [ChecklistReportListDataService],
})
export class ChecklistReportListModule {}
